import { ListData } from '@fi-app/components/items-list/list-data.service';
import {
    ItemsListElementType,
    ItemsListHeader,
    ItemsListHeaderProperties,
} from '@fi-app/components/items-list/items-list-header';
import { BusinessUnitCompanyInformationModel } from './business-unit-company-information.model';
import { Injector } from '@angular/core';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export class BillingCompanyInformationListData extends ListData<BusinessUnitCompanyInformationModel> {
    constructor(injector: Injector) {
        super(injector, true, 'BusinessUnitName');

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('billing.unit'),
                'BusinessUnitName',
                new ItemsListHeaderProperties('CcmListItem-Name', true, ItemsListElementType.A, {
                    Sref: FiStateNames.Billing.CompanyInformation.View,
                    SrefParams: (data) => ({ BusinessUnitId: data.BusinessUnitId }),
                }),
            ),
        );

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('unit_type'),
                'UnitStatusName',
                new ItemsListHeaderProperties('', true, ItemsListElementType.SpanPlain, {
                    GetClass: (data: BusinessUnitCompanyInformationModel) => {
                        return data && data.IsHeadQuarter ? 'CcmListItemRed CcmListItemBold' : '';
                    },
                }),
            ),
        );
    }
}
